// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__yM93U","contentContainer":"page_contentContainer__RuKqG","headerImg":"page_headerImg__Lccl1"};